import { navigateWindowTo, trackHeapEvent } from '@ratehub/base-ui';

import DEPOSIT_HEAP_EVENT_MAP from '../definitions/DepositHeapEventMap';


/**
 * Navigates to the product applyURL page and tracks deposit CTA heap event.
 * 
 * @param {Object} options - The options for navigating and tracking the deposit CTA.
 * @param {Object} options.product - The product object containing details of the product.
 * @param {boolean} [options.shouldNavigate=false] - Indicates whether to navigate to the product details/applyURL page.
 * @param {string} [options.provinceCode] - The province code for the product.
 * @param {string} [options.vertical] - The deposit vertical from DEPOSITS_VERTICALS definition.
 */
function trackHeapEventForDepositsAndNavigate({ product, shouldNavigate = false, provinceCode, vertical }) {
    trackHeapEvent(DEPOSIT_HEAP_EVENT_MAP[vertical], {
        href: product.detailsURL,
        provider: product.provider.name,
        monetized: product.isMonetized.toString(),
        slug: product.slug,
    });

    if (shouldNavigate) {
        const queryParams = { 
            ...(provinceCode && { province: provinceCode }),
            sponsored: product.isSponsored,
        };
        navigateWindowTo(
            product.applyURL,
            { isNewTab: true, queryParams },
        );
    }
}


export default trackHeapEventForDepositsAndNavigate;